var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.claim
    ? _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c("messages", { attrs: { messages: _vm.messages } }),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "loading" }, [
                _vm._v("Loading... "),
                _c("img", {
                  attrs: { src: "/images/loading.svg", width: "20" }
                })
              ])
            : _c("div", { staticClass: "row container-claim-form" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    !(
                      _vm.claim.vehicle_id ||
                      _vm.vehicle_detail_confirmed ||
                      _vm.claim_id
                    )
                      ? [
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c("el-autocomplete", {
                                attrs: {
                                  "fetch-suggestions": _vm.searchVehicle,
                                  placeholder: "Please search for a vehicle",
                                  disabled: _vm.vehicle_not_found
                                },
                                on: { select: _vm.selectVehicle },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v(
                                              _vm._s(item.make) +
                                                " " +
                                                _vm._s(item.model) +
                                                ", " +
                                                _vm._s(item.year)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "details" },
                                            [
                                              item.chassis
                                                ? _c("span", [
                                                    _c("strong", [
                                                      _vm._v("Chassis")
                                                    ]),
                                                    _vm._v(
                                                      " " + _vm._s(item.chassis)
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.stock_id
                                                ? _c("span", [
                                                    _c("strong", [
                                                      _vm._v("Stock ID")
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.stock_id)
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.sold_date
                                                ? _c("span", [
                                                    _c("strong", [
                                                      _vm._v("Sold Date")
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.sold_date)
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2642045130
                                ),
                                model: {
                                  value: _vm.vehicle_search_term,
                                  callback: function($$v) {
                                    _vm.vehicle_search_term = $$v
                                  },
                                  expression: "vehicle_search_term"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row cb-vehicle-not-found-wrapper"
                            },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  staticClass: "float-left",
                                  attrs: { id: "cb-vehicle-not-found" },
                                  model: {
                                    value: _vm.vehicle_not_found,
                                    callback: function($$v) {
                                      _vm.vehicle_not_found = $$v
                                    },
                                    expression: "vehicle_not_found"
                                  }
                                },
                                [_vm._v("I can’t find my vehicle")]
                              ),
                              _vm._v(" "),
                              _vm.vehicle_not_found
                                ? _c(
                                    "div",
                                    { staticClass: "form-row" },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "input-group col-md-4",
                                          attrs: {
                                            label: "Make",
                                            "label-for": _vm.getId("make"),
                                            state: _vm.fieldState("make"),
                                            "invalid-feedback": _vm.invalidField(
                                              "make"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: _vm.getId("make"),
                                              type: "text",
                                              state: _vm.fieldState("make"),
                                              placeholder: "Enter made"
                                            },
                                            model: {
                                              value: _vm.claim.make,
                                              callback: function($$v) {
                                                _vm.$set(_vm.claim, "make", $$v)
                                              },
                                              expression: "claim.make"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "input-group col-md-4",
                                          attrs: {
                                            label: "Model",
                                            "label-for": _vm.getId("model"),
                                            state: _vm.fieldState("model"),
                                            "invalid-feedback": _vm.invalidField(
                                              "model"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: _vm.getId("model"),
                                              type: "text",
                                              state: _vm.fieldState("model"),
                                              placeholder: "Enter model"
                                            },
                                            model: {
                                              value: _vm.claim.model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.claim,
                                                  "model",
                                                  $$v
                                                )
                                              },
                                              expression: "claim.model"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "input-group col-md-4",
                                          attrs: {
                                            label: "Chassis",
                                            "label-for": _vm.getId("chassis"),
                                            state: _vm.fieldState("chassis"),
                                            "invalid-feedback": _vm.invalidField(
                                              "chassis"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: _vm.getId("chassis"),
                                              type: "text",
                                              state: _vm.fieldState("chassis"),
                                              placeholder: "Enter chassis"
                                            },
                                            model: {
                                              value: _vm.claim.chassis,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.claim,
                                                  "chassis",
                                                  $$v
                                                )
                                              },
                                              expression: "claim.chassis"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: !_vm.vehicle_info_entered,
                                            size: "medium",
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.vehicle_detail_confirmed = true
                                            }
                                          }
                                        },
                                        [_vm._v("Confirm Vehicle Detail")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      : [
                          _c("div", [
                            _c("h3", [
                              _vm._v(
                                "\n                        Claim for\n                        "
                              ),
                              _vm.claim.vehicle_id
                                ? _c("span", { staticClass: "label" }, [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.claim.vehicle.make) +
                                        " " +
                                        _vm._s(_vm.claim.vehicle.model) +
                                        ", " +
                                        _vm._s(_vm.claim.vehicle.year) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vehicle_detail_confirmed
                                ? _c("span", { staticClass: "label" }, [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(this.claim.make) +
                                        " " +
                                        _vm._s(this.claim.model) +
                                        ", " +
                                        _vm._s(this.claim.chassis) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.claim.vehicle_id && _vm.claim.vehicle.stock_id
                                ? _c("div", { staticClass: "stock-id" }, [
                                    _vm._v(
                                      "Stock ID " +
                                        _vm._s(_vm.claim.vehicle.stock_id)
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "input-group col-md-6",
                                  attrs: {
                                    label:
                                      "Reason for / Details of this claim *",
                                    "label-for": _vm.getId("reason"),
                                    state: _vm.fieldState("reason"),
                                    "invalid-feedback": _vm.invalidField(
                                      "reason"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: _vm.getId("reason"),
                                      state: _vm.fieldState("reason"),
                                      rows: 6,
                                      required: "",
                                      placeholder: "Enter reason"
                                    },
                                    model: {
                                      value: _vm.claim.reason,
                                      callback: function($$v) {
                                        _vm.$set(_vm.claim, "reason", $$v)
                                      },
                                      expression: "claim.reason"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "input-group col-md-6",
                                  attrs: {
                                    label: "Repair cost (excl GST)",
                                    "label-for": _vm.getId("repair_cost"),
                                    state: _vm.fieldState("repair_cost"),
                                    "invalid-feedback": _vm.invalidField(
                                      "repair_cost"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: _vm.getId("repair_cost"),
                                      type: "text",
                                      state: _vm.fieldState("repair_cost"),
                                      placeholder: "Enter repair cost"
                                    },
                                    model: {
                                      value: _vm.claim.repair_cost,
                                      callback: function($$v) {
                                        _vm.$set(_vm.claim, "repair_cost", $$v)
                                      },
                                      expression: "claim.repair_cost"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "input-group col-md-6",
                                  attrs: {
                                    label: "Description",
                                    "label-for": _vm.getId("description"),
                                    state: _vm.fieldState("description"),
                                    "invalid-feedback": _vm.invalidField(
                                      "description"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: _vm.getId("description"),
                                      state: _vm.fieldState("description"),
                                      rows: 6,
                                      placeholder: "Enter description"
                                    },
                                    model: {
                                      value: _vm.claim.description,
                                      callback: function($$v) {
                                        _vm.$set(_vm.claim, "description", $$v)
                                      },
                                      expression: "claim.description"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _vm.$userIsSuperAdmin() && _vm.claim_id
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticClass: "input-group col-md-6",
                                      attrs: {
                                        label: "Claim Status",
                                        "label-for": _vm.getId("status"),
                                        state: _vm.fieldState("status"),
                                        "invalid-feedback": _vm.invalidField(
                                          "status"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          staticClass: "form-control",
                                          attrs: { id: _vm.getId("status") },
                                          model: {
                                            value: _vm.claim.status,
                                            callback: function($$v) {
                                              _vm.$set(_vm.claim, "status", $$v)
                                            },
                                            expression: "claim.status"
                                          }
                                        },
                                        _vm._l(_vm.claim_statuses, function(
                                          status
                                        ) {
                                          return _c(
                                            "option",
                                            { domProps: { value: status.id } },
                                            [_vm._v(_vm._s(status.name))]
                                          )
                                        }),
                                        0
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-row" }, [
                            _c(
                              "div",
                              { staticClass: "form-group col-md-6" },
                              [
                                _vm.claim.id
                                  ? [
                                      _vm.claim.status === 2 ||
                                      _vm.claim.status === 3
                                        ? _c(
                                            "b-btn",
                                            {
                                              staticClass: "btn",
                                              attrs: { type: "submit" }
                                            },
                                            [_vm._v("Update")]
                                          )
                                        : _vm.claim.status === 1
                                        ? _c(
                                            "b-btn",
                                            {
                                              staticClass: "btn",
                                              attrs: { type: "submit" }
                                            },
                                            [_vm._v("Submit")]
                                          )
                                        : _c(
                                            "b-btn",
                                            {
                                              staticClass: "btn",
                                              attrs: { type: "submit" }
                                            },
                                            [_vm._v("Save")]
                                          )
                                    ]
                                  : _c(
                                      "b-btn",
                                      {
                                        staticClass: "btn",
                                        attrs: { type: "submit" }
                                      },
                                      [_vm._v("Next")]
                                    )
                              ],
                              2
                            )
                          ])
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _vm.claim.id
                    ? _c(
                        "div",
                        { staticClass: "form-row" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "input-group col-md-6",
                              attrs: {
                                label: "upload documents and/or photos",
                                "label-for": _vm.getId("upload"),
                                state: _vm.fieldState("upload"),
                                "invalid-feedback": _vm.invalidField("upload")
                              }
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: "#",
                                    "auto-upload": false,
                                    "on-change": _vm.handleAddFile,
                                    "on-remove": _vm.handleRemoveFile,
                                    "file-list": _vm.claim.files
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" }
                                    },
                                    [_vm._v("Click to upload")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip",
                                      attrs: { slot: "tip" },
                                      slot: "tip"
                                    },
                                    [
                                      _c("p", [
                                        _vm._v("uploads photos or quotes here.")
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "A list of possible required documents"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "example-docs" },
                                        [
                                          _c("li", [
                                            _vm._v("Quotes or Invoices")
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [_vm._v("Photos")]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _vm._v("Compliance Fail Sheets")
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [_vm._v("Delivery Dockets")])
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d25e145", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d25e145","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Claims/EditClaim.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7d25e145","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Claims/EditClaim.vue
// module chunks = 0